import { render, staticRenderFns } from "./OzPopoverModal.vue?vue&type=template&id=ad6665c4&"
import script from "./OzPopoverModal.vue?vue&type=script&lang=ts&"
export * from "./OzPopoverModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports